module.exports = __webpack_public_path__ + "static/media/evaluate-helpful-selected.44ee11ed.svg";